<template lang="html">
  <layout-public class="sign-up-practice">
    <div>
      <h4 class="snug">Dental Professionals</h4>
      <h1>Sign Up</h1>
      <div class="alert alert-app">
        <p class="snug"><strong>Need an invite code?</strong> <a href="mailto:info@healthassuranceplan.com">Email</a> our team to get your invite code, and if you'd like, to schedule a free demo.</p>
      </div>
      <input type="text" name="invite" class="form-control form-control-bold" placeholder="Invite code" v-model="invite" @keyup.enter="signUp">
      <input type="text" name="email" class="form-control" placeholder="Enter email" v-model="email" @keyup.enter="signUp">
      <input type="password" name="password" class="form-control" placeholder="Enter password" v-model="password" @keyup.enter="signUp">
      <label class="normal-weight form-check">
        <input type="checkbox" name="termsAccepted" v-model="termsAccepted" value="termsAccepted" class="form-check-input">
        <small>I accept the <a href="https://healthassuranceplan.com/terms-of-service/" target="_blank">terms of service</a></small>.
      </label>

      <list-errors :errors="errors"></list-errors>

      <p v-if="!loading"><button class="btn btn-app" @click="signUp">Sign Up<i class="far fa-angle-right fa-fw fa-right"></i></button></p>

      <p v-if="loading"><i class="far fa-fw fa-pulse fa-spinner"></i></p>

      <hr class="hr-form-footer" />

      <p>Already signed up? <router-link :to="{path: '/log-in', query: { redirect: this.$route.query.redirect } }">Log in</router-link>.</p>
    </div>
  </layout-public>
</template>

<script>
import {mapGetters} from 'vuex'
import LayoutPublic from '../components/LayoutPublic.vue'
import ListErrors from '../components/ListErrors.vue'

export default {
  props: [''],
  data () {
    return {
      email: '',
      password: '',
      errors: [],
      termsAccepted: false,
      loading: false,
      invite: null,
      inviteValid: 'hBGvR4r_fD_HxwhMLCkP',
    }
  },
  components: {
    LayoutPublic, ListErrors
  },
  computed: {
    ...mapGetters(['user','guarantorPracticeUrl']),
    // get next route from querystring, set in FirebaseApp.js, or default
    nextRoute () {
      return this.$route.query.redirect || '/set-up'
    },
  },
  watch: {
    //  when signUp completes, go to requested page
    user (auth) {
      if(auth) {
        this.$router.replace(this.nextRoute)
      }
    }
  },
  methods: {
    async signUp () {
      this.loading = true;
      // reset errors
      this.errors = [];
      // if privacy policy not accepted, show error
      if(!this.termsAccepted) {
        this.errors.push("You must accept the terms of service and privacy policy.")
        this.loading = false;
        return;
      }
      // validate invite code
      if(!this.invite || this.invite !== this.inviteValid) {
        this.errors.push("You must enter a valid invite code to sign up.")
        this.loading = false;
        return;
      }
      //  attempt signUp
      let result = await this.$firebase.signUp(this.email, this.password)
      // if result doesn't contain user, it's an error
      // console.log(result);
      if(result && result.code) {
        this.loading = false;
        if(result.code == "auth/invalid-email") {
          this.errors.push("Oops, that's not a valid email address.")
        }
        else if(result.code == "auth/weak-password") {
          this.errors.push("Oops, your password must be at least 6 characters.")
        }
        else {
          this.errors.push(result.message);
        }
      }
      // if no errors, send email verification
      else {
        this.$firebase.verifyEmail()
          .then(() => {
            // this.$router.replace(this.nextRoute)
          })
          .catch(err => console.log(err));
      }
    },
  },
  created () {
    if(this.user && this.$route.path !== this.nextRoute) {
      this.$router.replace(this.nextRoute)
    }
    // if guarantorPracticeUrl exists, redirect the user to that practice's signup page
      // so they don't sign up as a practcie on accident
    if(this.guarantorPracticeUrl) {
      this.$router.replace(`/${this.guarantorPracticeUrl}/sign-up?redirect=%2Fagreement`)
    }
  },
  mounted () {
    if(this.user && this.$route.path !== this.nextRoute) {
      this.$router.replace(this.nextRoute)
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.layout-public .container:before {
  // background: url('../assets/img/ha-splash-faces.png') center right no-repeat;
  background: none;
}

.form-check {
  margin-bottom: 30px;
}
hr.hr-form-footer {
  margin-bottom: 30px;
}
.form-control-bold {
  border-width: 2px;
  border-color: @major-color;
}

</style>
